import React from "react";

interface myComponentProps {
  children?: React.ReactNode;
  headerNavComponent?: React.ReactNode;
  sideMenuComponent?: React.ReactNode;
  sideMenuBg?: string;
  hideSideMenuBox?: boolean;
  headerNavBg?: string;
  hideHeaderNavBox?: boolean;
  collapse?: boolean;
  onClickCollapse?: () => void;
  collapsible?: boolean;
  logo?: any;
  collapseIcon?: any;
  collapseColor?: string;
  barIcon?: any;
  barColor?: string;
  showMobileMenu?: boolean;
  setShowMobileMenu?: () => void;
  sideMenuWidth?: any;
  sideMenuCollapseWidth?: any;
  headerNavHeight?: any;
  className?: string;
}

const RazorLayout = ({
  children,
  sideMenuBg,
  hideSideMenuBox,
  hideHeaderNavBox,
  headerNavBg,
  headerNavComponent,
  sideMenuComponent,
  collapse,
  collapsible,
  onClickCollapse,
  logo,
  collapseIcon,
  collapseColor,
  barIcon,
  setShowMobileMenu,
  barColor,
  showMobileMenu,
  sideMenuWidth,
  sideMenuCollapseWidth,
  headerNavHeight,
  className,
}: myComponentProps) => {
  const collapseDefaultIcon = (
    <svg
      className={`img`}
      width="20"
      height="15"
      viewBox="0 0 20 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_13760_88399)">
        <path
          d="M18.75 7.15458L1.96883 7.15458L3.56152 5.56189L3.20365 5.20402L0.999998 7.40767L3.20365 9.61133L3.56152 9.25346L1.96883 7.66076L18.75 7.66076V7.15458Z"
          fill={collapseColor || "#020202"}
          stroke={collapseColor || "#020202"}
          strokeLinejoin="round"
        />
        <path
          d="M4 12.6113L18.5 12.6113"
          stroke={collapseColor || "#020202"}
          strokeWidth="1.5"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M4 1.61133L18.5 1.61133"
          stroke={collapseColor || "#020202"}
          strokeWidth="1.5"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_13760_88399">
          <rect
            width="20"
            height="14"
            fill="white"
            transform="matrix(1 0 0 -1 0 14.6113)"
          />
        </clipPath>
      </defs>
    </svg>
  );

  return (
    <div
      style={
        {
          "--side-menu-width": sideMenuWidth ? sideMenuWidth : "23rem",
          "--header-nav-height": headerNavHeight ? headerNavHeight : "5rem",
          "--side-menu-collapse-width": sideMenuCollapseWidth
            ? sideMenuCollapseWidth
            : "7rem",
        } as React.CSSProperties
      }
      className={`dashboard-general-layout-wrapper-index  ${
        className ? className : ""
      }`}
    >
      {/* sidemenu start */}
      {!hideSideMenuBox && (
        <div
          style={{ backgroundColor: sideMenuBg ? sideMenuBg : "" }}
          className={`side-menu-wrapper-box ${
            collapse && collapsible ? "side-menu-wrapper-box-collapsed" : ""
          } ${showMobileMenu ? "side-menu-wrapper-box-show" : ""}`}
        >
          {/* collapsible and logo start */}

          <div className="collapsible-logo-box">
            {/* logo here start */}
            {logo && (
              <div className="logo-box">
                <figure className="img-box">{logo}</figure>
              </div>
            )}
            {/* logo here end */}
            {/* collapse box start */}
            {collapsible && (
              <div
                onClick={() => {
                  onClickCollapse && onClickCollapse();
                }}
                className={`collapse-icon-box ${
                  collapse ? "collapse-icon-box-collapsed" : ""
                }`}
              >
                <div className="img-box">
                  {collapseIcon || collapseDefaultIcon}
                </div>
              </div>
            )}
            {/* collapse box end */}
          </div>

          {/* collapsible and logo end */}
          {/* side menu component start */}
          {sideMenuComponent && <>{sideMenuComponent}</>}
          {/* side menu component end */}
        </div>
      )}
      {/* side menu end */}
      {/* mobile blurr start */}
      {showMobileMenu && (
        <div
          onClick={() => {
            setShowMobileMenu && setShowMobileMenu();
          }}
          className="mobile-blur-box"
        ></div>
      )}
      {/* mobile blurr end */}
      {/* main header wrapper startx */}
      <div
        className={`main-header-wrapper-content-box ${
          collapse && collapsible
            ? "main-header-wrapper-content-box-collapsed"
            : ""
        } ${hideSideMenuBox ? "main-header-wrapper-content-box-full" : ""}`}
      >
        {/* header nav start */}
        {!hideHeaderNavBox && (
          <div
            style={{ backgroundColor: headerNavBg ? headerNavBg : "" }}
            className="header-nav-box-wrapper"
          >
            {/* headeer nave component start */}
            <div className="component-box">
              {" "}
              {headerNavComponent && <>{headerNavComponent}</>}
            </div>

            {/* headeer nave component end */}
            {/* mobile menu start */}
            {!showMobileMenu && (
              <div
                onClick={() => {
                  setShowMobileMenu && setShowMobileMenu();
                }}
                className="menu-bar-box"
              >
                {!barIcon ? (
                  <div className="line-box">
                    <div
                      style={{ backgroundColor: barColor ? barColor : "" }}
                      className="line"
                    ></div>
                    <div
                      style={{ backgroundColor: barColor ? barColor : "" }}
                      className="line"
                    ></div>
                    <div
                      style={{ backgroundColor: barColor ? barColor : "" }}
                      className="line"
                    ></div>
                  </div>
                ) : (
                  <figure className="img-box">{barIcon}</figure>
                )}
              </div>
            )}
            {/* mobile menu end */}
          </div>
        )}
        {/* header nav end */}
        {/* main content box start */}
        <div className="main-content-wrapper">
          <div className="main-content-inner-wrapper">{children}</div>
        </div>
        {/* main content box end */}
      </div>
      {/* main header wrapper end */}
    </div>
  );
};

export default RazorLayout;
